import {Component} from '@angular/core';
import {EventResponse} from "../../../shared/model/response/event/event-response.model";
import {PageInfo} from "../../../shared/model/response/page-info.model";
import {AuthtokenResponse} from "../../../shared/model/response/auth/authtoken-response.model";
import {EventFilterModel} from "../../../shared/model/request/event-filter.model";
import {DatePipe} from "@angular/common";
import {EventService} from "../../../service/api/event.service";
import {AuthenticationService} from "../../../service/authentication-service";
import {PaginatorState} from "primeng/paginator";
import {EventStatus} from "../../../shared/enums/status.enum";

@Component({
    selector: 'app-pending-events',
    templateUrl: './pending-events.component.html',
    styleUrls: ['./pending-events.component.css'],
    standalone: false
})
export class PendingEventsComponent {
  events: EventResponse[];
  pagination: PageInfo

  user: AuthtokenResponse

  eventFilters: EventFilterModel
  hasEvents: boolean = true

  constructor(
    private datePipe: DatePipe,
    private eventService: EventService,
    private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    this.user = this.authenticationService._user.getValue()
    this.fetchEvents({})
  }

  onFilterSubmit($event: EventFilterModel) {
    this.eventFilters = $event
    this.fetchEvents(this.eventFilters)
  }

  fetchEvents(filters: EventFilterModel, page?: number) {
    filters.eventStatus = EventStatus.PENDING
    this.eventService.getEvents(page, filters)
      .subscribe({
          next: (value) => {
            this.events = value?.data
            this.pagination = value.pageInfo
            this.hasEvents = this.events.length > 0
          },
          error: () => {
            if (page == 0) {
              this.hasEvents = false;
              this.events = null;
            }
          }
        }
      )
  }

  onPageChange($event: PaginatorState) {
    this.fetchEvents(this.eventFilters, $event.page)
  }
}
